var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeature1Img(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 540,
    viewBox: "0 0 540 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_946)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 540,
    rx: 270,
    fill: "#F5FAFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M345.269 284.828L376.375 273.476V549.732H345.269V284.828Z",
    fill: "url(#paint0_linear_50_946)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M144.53 263.244L156.765 250.966H203.424V549.732H144.53V263.244Z",
    fill: "url(#paint1_linear_50_946)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M66.5314 120H22.6975V550.023H66.5314V120Z",
    fill: "url(#paint2_linear_50_946)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M123.378 218.225H84.8063V549.733H123.378V218.225Z",
    fill: "url(#paint3_linear_50_946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M303.379 177.296H250.291V549.731H303.379V177.296Z",
    fill: "url(#paint4_linear_50_946)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M426.145 265.29H386.743V549.732H426.145V265.29Z",
    fill: "url(#paint5_linear_50_946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M512.414 258.129H455.178V549.732H512.414V258.129Z",
    fill: "url(#paint6_linear_50_946)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M487.527 293.939H441.905V549.732H487.527V293.939Z",
    fill: "url(#paint7_linear_50_946)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M542.301 218.187H470.393V550.022H542.301V218.187Z",
    fill: "url(#paint8_linear_50_946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M657.49 379.78H303.278V549.913H657.49V379.78Z",
    fill: "url(#paint9_linear_50_946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M217.94 338.958H78.1699V549.732H217.94V338.958Z",
    fill: "url(#paint10_linear_50_946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M49.3576 401.168H-34.8625V550.022H49.3576V401.168Z",
    fill: "url(#paint11_linear_50_946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M203.451 296.582L215.729 287.28H262.552V550.022H203.451V296.582Z",
    fill: "url(#paint12_linear_50_946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M394.624 231.525H368.495V549.732H394.624V231.525Z",
    fill: "url(#paint13_linear_50_946)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.9716 -52H44.1389V515.947H46.9716V-52Z",
    fill: "#CDECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.507 -52H245.966V515.947H249.507V-52Z",
    fill: "#CDECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.333 -52H448.5V515.947H451.333V-52Z",
    fill: "#CDECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.665 64.7651C297.665 63.9114 296.964 63.2115 296.133 63.2115C290.194 63.2115 268.992 63.2115 263.053 63.2115C262.223 63.2115 261.521 63.9114 261.521 64.7651C261.521 65.6188 262.223 66.3018 263.053 66.3018C268.992 66.3018 290.194 66.3018 296.133 66.3018C296.964 66.3018 297.665 65.6188 297.665 64.7651Z",
    fill: "#D6EDFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.342 72.4718C284.342 71.6181 283.657 70.9182 282.771 70.9182C278.62 70.9182 267.253 70.9182 263.062 70.9182C262.216 70.9182 261.53 71.6181 261.53 72.4718C261.53 73.3255 262.216 74.0085 263.062 74.0085C267.253 74.0085 278.62 74.0085 282.771 74.0085C283.657 74.0085 284.342 73.3255 284.342 72.4718Z",
    fill: "#D6EDFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.665 98.7013C297.665 97.8476 296.964 97.1476 296.133 97.1476C290.194 97.1476 268.992 97.1476 263.053 97.1476C262.223 97.1476 261.521 97.8476 261.521 98.7013C261.521 99.555 262.223 100.238 263.053 100.238C268.992 100.238 290.194 100.238 296.133 100.238C296.964 100.238 297.665 99.555 297.665 98.7013Z",
    fill: "#D6EDFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.342 106.408C284.342 105.554 283.657 104.854 282.771 104.854C278.62 104.854 267.253 104.854 263.062 104.854C262.216 104.854 261.53 105.554 261.53 106.408C261.53 107.262 262.216 107.945 263.062 107.945C267.253 107.945 278.62 107.945 282.771 107.945C283.657 107.945 284.342 107.262 284.342 106.408Z",
    fill: "#D6EDFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.665 130.516C297.665 129.663 296.964 128.963 296.133 128.963C290.194 128.963 268.992 128.963 263.053 128.963C262.223 128.963 261.521 129.663 261.521 130.516C261.521 131.37 262.223 132.053 263.053 132.053C268.992 132.053 290.194 132.053 296.133 132.053C296.964 132.053 297.665 131.37 297.665 130.516Z",
    fill: "#D6EDFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.342 138.223C284.342 137.369 283.657 136.669 282.771 136.669C278.62 136.669 267.253 136.669 263.062 136.669C262.216 136.669 261.53 137.369 261.53 138.223C261.53 139.077 262.216 139.76 263.062 139.76C267.253 139.76 278.62 139.76 282.771 139.76C283.657 139.76 284.342 139.077 284.342 138.223Z",
    fill: "#D6EDFB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_50_946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.268 506.477C149.268 506.477 132.256 517.981 125.409 517.255C124.683 517.255 123.957 516.944 123.438 516.426C118.978 511.866 115.347 503.782 115.347 503.782C115.347 503.782 117.526 500.88 124.061 508.653L128.21 504.818L119.6 496.216C119.6 496.216 124.476 492.382 132.671 497.253C132.359 496.631 127.069 485.127 131.115 469.477L111.094 450.2L128.833 434.758L130.285 433.514C130.285 433.514 131.426 434.654 133.189 436.416C134.953 438.178 137.339 440.251 139.932 442.531C146.156 448.024 153.728 453.931 157.048 453.931C163.064 453.724 149.268 506.477 149.268 506.477Z",
    fill: "#F1B287"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.197 498.911C136.197 498.911 126.55 508.86 125.513 517.255C124.787 517.255 124.061 516.944 123.542 516.426C119.082 511.866 115.451 503.782 115.451 503.782C115.451 503.782 117.629 500.88 124.164 508.653L128.314 504.818L119.704 496.216C119.704 496.216 124.579 492.382 132.774 497.253C132.463 496.631 127.173 485.127 131.218 469.477L111.198 450.2L128.936 434.758L133.189 436.416C134.953 438.074 137.339 440.251 139.932 442.531C136.197 448.024 128.106 459.424 128.106 459.424L135.056 468.855C135.16 468.752 130.803 492.485 136.197 498.911Z",
    fill: "#FFDAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.314 504.819C129.247 502.02 130.803 499.429 132.774 497.253",
    stroke: "#E19C79",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.113 372.056C442.416 375.994 439.201 379.414 435.466 382.42C404.243 408.226 332.252 420.974 332.252 420.974C332.252 420.974 329.866 424.601 326.132 429.679C319.493 438.903 308.601 453.102 299.68 460.15C295.946 463.155 292.523 464.917 289.929 464.399L303.415 514.25L309.431 535.911C309.431 535.911 247.399 563.064 141.177 532.076C141.177 532.076 139.932 518.188 140.866 515.286C140.866 515.183 140.969 514.975 140.969 514.872C142.007 512.902 143.459 511.141 145.119 509.69C145.119 509.69 144.496 500.777 144.185 491.76C143.874 485.956 143.874 480.152 144.392 474.452C145.119 469.892 148.542 458.802 150.201 453.413L151.135 450.304L145.845 400.867L144.289 386.565L144.185 385.84C144.185 385.736 144.185 385.632 144.185 385.529L143.355 377.859L116.073 386.151C116.073 386.151 117.526 389.363 119.497 393.82C123.127 402.008 128.314 414.548 129.455 419.523C129.559 419.937 129.662 420.352 129.766 420.766C132.256 428.021 141.903 434.551 141.903 434.551L116.073 464.71L108.397 459.424C107.464 460.15 106.426 460.771 105.285 461.393C100.306 464.088 89.7253 468.13 78.1073 462.015C73.1281 459.217 68.7713 455.382 65.3482 450.718C45.5352 424.187 36.6142 402.629 39.5187 377.445C42.4232 352.26 155.907 274.426 178.52 275.256L212.026 282.614C212.752 281.992 214.723 280.438 216.175 280.541C222.296 280.852 222.399 287.9 222.399 287.9L297.502 300.129C297.502 300.129 305.282 296.191 306.63 296.295C307.564 296.398 308.601 296.709 309.431 297.227C310.261 297.746 310.987 298.471 311.402 299.3C311.402 299.3 330.904 287.692 337.128 290.387C357.77 299.3 460.258 349.047 445.113 372.056Z",
    fill: "url(#paint14_linear_50_946)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M184.122 495.387C175.616 504.715 164.102 510.933 151.654 513.006C147.712 513.628 144.185 514.25 141.177 514.872C142.214 512.902 143.666 511.14 145.326 509.69C145.326 509.69 144.704 500.776 144.392 491.76C153.21 497.564 168.562 504.197 184.122 495.387Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.409 453.413L151.343 450.304L146.052 400.867C153.936 412.164 182.151 450.718 201.549 454.864C221.881 459.217 167.629 466.886 150.409 453.413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M303.414 514.457C282.253 512.073 252.274 506.684 249.266 495.594C244.598 478.286 267.316 467.922 299.68 460.357C295.946 463.362 292.523 465.124 289.929 464.606L303.414 514.457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M435.466 382.419C404.243 408.226 332.252 420.974 332.252 420.974C332.252 420.974 329.866 424.601 326.132 429.679C315.551 404.391 313.892 376.305 321.568 349.98C321.568 349.98 327.066 379.932 350.094 387.083C350.094 387.083 332.46 373.921 338.684 342.414C338.684 342.414 344.7 379.518 383.807 389.778C402.79 394.96 421.359 389.467 435.466 382.419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.496 385.839L143.666 377.859L116.385 386.15C116.385 386.15 117.837 389.363 119.808 393.82C109.331 392.783 89.5179 402.422 86.0947 391.851C81.9454 379.103 107.567 383.456 107.567 383.456L131.633 369.464C127.069 349.876 138.687 335.263 138.687 335.263L140.866 348.944C141.903 323.034 152.069 308.835 152.069 308.835C143.666 329.252 143.978 379.828 144.496 385.839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.214 434.447L116.385 464.606L108.708 459.32C107.775 460.046 106.737 460.668 105.596 461.29C100.617 463.984 90.0365 468.026 78.4185 461.911C86.8208 450.304 104.144 433.307 124.683 426.674C119.6 434.136 115.036 442.013 111.094 450.096L116.385 455.278C116.488 455.278 129.766 440.251 142.214 434.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M205.076 301.476C205.076 304.171 203.416 334.33 225.408 342.311C247.399 350.395 266.901 336.714 266.901 336.714C266.901 336.714 233.187 369.257 212.648 351.846C192.006 334.538 205.076 301.476 205.076 301.476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.654 377.134C400.093 399.831 427.894 395.685 449.678 366.355C449.678 366.355 467.831 343.036 466.482 317.852C465.237 292.667 459.221 210.584 380.695 231.623C367.729 235.043 337.646 275.463 335.053 286.449C333.912 291.527 321.775 317.333 310.053 343.969",
    fill: "#FD3E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.654 377.134C400.093 399.831 427.894 395.685 449.678 366.355C449.678 366.355 467.831 343.036 466.482 317.852C465.237 292.667 459.221 210.584 380.695 231.623C367.729 235.043 337.646 275.463 335.053 286.449C333.912 291.527 321.775 317.333 310.053 343.969",
    stroke: "#DA2858",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.398 136.067C272.398 136.067 294.39 132.75 309.638 146.431C328.933 163.635 350.613 210.17 319.701 287.278C319.701 287.278 274.162 257.015 196.362 277.328C196.362 277.328 203.105 259.295 191.28 202.293C185.989 176.486 199.371 117.101 272.398 136.067Z",
    fill: "#5B5863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1 329.459C271.569 334.745 306.112 298.782 306.112 298.782C306.112 298.782 288.477 296.605 286.817 288.314C281.735 262.197 302.17 229.861 302.17 229.861C302.17 229.861 223.229 232.038 237.026 249.864C239.619 253.077 241.694 256.704 243.25 260.539C248.021 272.25 244.702 281.163 242.212 283.34C242.005 283.443 241.797 283.65 241.59 283.754C236.818 285.931 217.213 282.718 217.213 282.718C217.213 282.718 209.433 324.692 239.1 329.459Z",
    fill: "#FFBE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.316 283.339C266.486 289.662 277.793 258.673 277.793 258.673C277.793 258.673 270.843 256.6 262.025 256.6C256.112 256.6 249.37 257.533 243.353 260.539C248.125 272.354 244.806 281.163 242.316 283.339Z",
    fill: "#F2AE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.622 213.59C309.535 180.632 303 141.042 252.689 144.358C216.798 146.742 217.109 186.021 219.495 197.733C223.54 217.424 217.731 225.197 223.955 241.78C228.416 253.698 238.685 267.068 250.718 272.043C258.187 275.152 288.27 254.009 290.552 244.371",
    fill: "#FFBE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.672 156.898C271.672 156.898 268.457 195.971 303 210.17L319.182 172.548L294.701 145.394L257.876 134.719C202.794 138.14 179.039 172.341 209.64 263.441C209.64 263.648 201.031 155.137 271.672 156.898Z",
    fill: "#5B5863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.427 211.828C294.908 207.475 306.112 196.282 309.846 203.433C316.277 215.662 311.609 226.234 304.97 230.587C301.962 232.452 298.228 235.976 295.635 232.659",
    fill: "#FFBE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.427 211.828C294.908 207.475 306.112 196.282 309.846 203.433C316.277 215.662 311.609 226.234 304.97 230.587C301.962 232.452 298.228 235.976 295.635 232.659",
    stroke: "#F2AE8B",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204.765 200.738C204.35 203.329 204.039 206.024 203.935 208.719",
    stroke: "#DBDBDB",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M265.967 149.747C238.063 149.022 212.13 166.744 206.01 194.727",
    stroke: "#DBDBDB",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.988 141.767C260.988 141.767 220.739 132.336 205.698 158.971",
    stroke: "#DBDBDB",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M293.56 188.301C295.946 191.722 298.954 194.831 302.274 197.422",
    stroke: "#DBDBDB",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.585 147.053C279.66 159.8 284.017 172.134 290.344 183.43",
    stroke: "#DBDBDB",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M318.041 268.001C317.315 271.214 316.485 274.323 315.551 277.536",
    stroke: "#DBDBDB",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M315.759 214.833C322.294 229.343 321.879 247.376 319.182 262.611",
    stroke: "#DBDBDB",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.987 240.018C311.298 245.511 310.468 251.004 308.497 256.082C306.527 261.264 303.518 265.928 299.68 269.763",
    stroke: "#DBDBDB",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.419 151.716C299.265 160.94 304.348 170.89 312.232 179.285C320.634 188.198 328.933 198.355 330.489 210.895",
    stroke: "#DBDBDB",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.772 142.078C284.743 143.322 286.506 144.876 288.166 146.534",
    stroke: "#DBDBDB",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.425 356.613C419.595 356.82 418.869 356.924 418.039 357.028C396.463 360.137 372.189 342.207 364.098 320.754C357.667 303.757 363.268 284.583 366.38 276.292C367.314 273.701 368.04 272.25 368.04 272.25C381.11 253.698 456.835 289.973 457.665 310.079C458.391 330.081 442.52 351.742 420.425 356.613Z",
    fill: "#951638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.076 312.773C444.076 312.773 439.823 344.591 417.935 357.028C396.359 360.137 372.086 342.207 363.994 320.754C357.563 303.757 363.165 284.583 366.277 276.292C391.795 261.782 444.076 312.773 444.076 312.773Z",
    fill: "#F2AE8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.762 329.563C354.762 329.563 379.347 364.801 408.081 367.806C436.815 370.708 455.175 346.56 456.316 328.319",
    stroke: "#DA2858",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.966 170.372C343.144 164.361 358.6 166.33 363.579 185.192C368.455 204.055 387.853 249.864 387.853 249.864C387.853 249.864 464.926 136.481 478.723 132.128C492.519 127.776 487.125 147.364 468.661 174.621C468.661 174.621 485.984 171.615 490.548 174.621C495.112 177.626 492.83 196.074 495.32 202.396C499.365 213.175 490.341 215.455 490.341 215.455C494.801 215.559 499.054 217.217 502.374 220.015C507.353 224.679 504.863 243.853 506.212 249.242C507.664 254.631 498.121 259.191 498.121 259.191C498.121 259.191 520.838 271.524 515.755 274.634C507.145 279.816 502.166 274.53 502.166 274.53C502.166 274.53 467.208 318.37 440.964 328.112C414.616 337.854 363.372 299.093 357.874 277.95C352.376 256.808 358.911 258.155 354.762 223.021C350.613 187.887 340.966 170.372 340.966 170.372Z",
    fill: "#FFBE9D",
    stroke: "#F1A781",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.412 100.725L351.858 127.154C348.227 128.086 346.049 131.818 347.086 135.341L395.114 319.303C396.048 322.93 399.782 325.106 403.309 324.07L504.863 297.642C508.494 296.709 510.673 292.978 509.635 289.454L461.607 105.597C460.673 101.969 457.043 99.7927 453.412 100.725Z",
    fill: "#5B5863",
    stroke: "#5B5863",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.218 121.868C395.322 122.075 395.322 122.283 395.218 122.49C395.218 122.697 395.114 122.904 395.01 123.112C394.907 123.319 394.803 123.423 394.595 123.63C394.388 123.734 394.18 123.837 393.973 123.941C393.766 124.045 393.558 124.045 393.351 123.941C393.143 123.941 392.936 123.837 392.728 123.734C392.521 123.63 392.417 123.526 392.21 123.319C392.106 123.112 392.002 122.904 391.898 122.697C391.795 122.49 391.795 122.283 391.898 122.075C391.898 121.868 392.002 121.661 392.106 121.454C392.21 121.246 392.313 121.143 392.521 120.935C392.728 120.832 392.936 120.728 393.143 120.624C393.558 120.521 393.973 120.624 394.388 120.832C394.803 121.143 395.114 121.454 395.218 121.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.172 116.479C416.172 116.582 416.172 116.79 416.172 116.893C416.172 116.997 416.068 117.204 416.068 117.308C415.964 117.412 415.861 117.515 415.757 117.619C415.653 117.722 415.55 117.722 415.342 117.826C415.135 117.826 414.927 117.826 414.72 117.826C414.512 117.722 414.408 117.619 414.201 117.515C414.097 117.308 413.994 117.204 413.994 116.997C413.994 116.79 413.994 116.582 414.097 116.375C414.201 116.168 414.305 116.064 414.512 115.961C414.72 115.857 414.927 115.857 415.135 115.857C415.342 115.857 415.55 115.961 415.653 116.064C415.964 116.064 416.068 116.271 416.172 116.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.089 118.966L398.849 122.075C398.641 122.179 398.434 122.386 398.537 122.594L398.641 122.801C398.745 123.008 398.952 123.215 399.16 123.112L411.4 120.003C411.608 119.899 411.815 119.692 411.711 119.484L411.608 119.277C411.608 119.07 411.4 118.966 411.089 118.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.599 107.462L506.212 289.972C506.523 291.009 506.316 292.045 505.797 292.978C505.278 293.911 504.345 294.533 503.411 294.844L403.102 320.857C402.064 321.168 401.027 320.961 400.093 320.443C399.16 319.924 398.537 318.992 398.226 318.059L350.613 135.549C350.302 134.512 350.509 133.476 351.028 132.543C351.546 131.61 352.48 130.988 353.414 130.678L373.953 125.288C374.575 125.081 375.301 125.185 375.924 125.392C376.546 125.599 377.168 126.014 377.48 126.636L378.932 128.812C379.347 129.33 379.866 129.745 380.488 130.056C381.11 130.263 381.836 130.367 382.459 130.159L427.583 118.448C428.205 118.241 428.827 117.93 429.242 117.412C429.657 116.893 429.968 116.272 430.072 115.65L430.383 113.059C430.487 112.437 430.694 111.711 431.213 111.193C431.628 110.675 432.25 110.364 432.873 110.157L453.412 104.767C454.449 104.457 455.487 104.664 456.42 105.182C457.561 105.597 458.287 106.426 458.599 107.462Z",
    fill: "#FD3E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.574 207.268C455.279 194.002 449.263 178.663 435.985 172.963C422.707 167.263 407.355 173.274 401.649 186.54C395.944 199.806 401.96 215.144 415.238 220.844C428.412 226.545 443.868 220.534 449.574 207.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M446.877 173.792C451.13 177.626 454.346 182.808 455.902 188.716C457.458 194.623 457.25 200.738 455.59 206.127M395.633 187.472C393.869 192.965 393.662 198.976 395.322 204.884C396.981 210.791 400.093 215.973 404.346 219.808L395.633 187.472Z",
    stroke: "white",
    strokeWidth: 2.98177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M448.225 164.568C455.59 169.75 461.192 177.316 463.682 186.643C466.171 195.971 465.134 205.402 461.399 213.486M389.72 180.218C385.986 188.301 384.948 197.733 387.438 207.06C389.928 216.388 395.529 223.954 402.894 229.136L389.72 180.218Z",
    stroke: "white",
    strokeWidth: 3.97569,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M451.545 154.411C462.126 160.837 470.217 171.201 473.744 184.052C477.167 196.904 475.3 209.962 469.387 220.741M381.836 172.963C375.924 183.741 374.057 196.8 377.48 209.651C380.903 222.503 389.098 232.867 399.678 239.292L381.836 172.963Z",
    stroke: "white",
    strokeWidth: 4.96962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.823 211.828C415.031 212.346 415.446 212.76 415.965 212.968C416.483 213.175 417.106 213.279 417.624 213.071L426.234 210.584C426.234 210.791 426.338 210.999 426.338 211.102C426.442 211.517 426.649 211.931 426.96 212.346C427.271 212.76 427.583 212.968 427.998 213.279C428.412 213.486 428.827 213.693 429.346 213.693C429.761 213.693 430.28 213.693 430.695 213.59C431.109 213.486 431.524 213.279 431.939 212.968C432.354 212.657 432.562 212.346 432.873 211.931C433.08 211.517 433.288 211.102 433.288 210.584C433.288 210.169 433.288 209.651 433.184 209.237C433.08 209.029 433.08 208.926 432.977 208.719L441.586 206.231C442.105 206.128 442.624 205.713 442.935 205.195C443.246 204.677 443.35 204.158 443.246 203.537C443.142 203.226 443.039 202.915 442.935 202.707C442.728 202.396 442.52 202.189 442.209 202.086C441.898 201.878 441.69 201.775 441.379 201.775C441.068 201.775 440.757 201.775 440.445 201.878L439.719 201.464C438.163 200.531 437.022 199.08 436.504 197.318L434.844 191.722C434.221 189.441 432.665 187.369 430.695 186.125C428.62 184.778 426.234 184.259 423.848 184.674C424.263 184.259 424.471 183.638 424.574 183.119C424.678 182.601 424.471 181.876 424.159 181.461C423.848 180.943 423.33 180.528 422.811 180.321C422.292 180.114 421.67 180.114 421.047 180.217C420.425 180.425 420.01 180.736 419.595 181.254C419.284 181.772 419.076 182.29 419.076 182.912C419.076 183.534 419.284 184.052 419.699 184.57C420.114 185.089 420.632 185.399 421.151 185.503C418.869 186.436 417.106 188.198 416.068 190.478C415.031 192.654 414.823 195.245 415.55 197.525L417.209 203.226C417.521 204.262 417.624 205.298 417.417 206.335C417.313 207.371 416.898 208.304 416.276 209.237C415.965 209.34 415.653 209.444 415.446 209.651C415.238 209.859 415.031 210.066 414.927 210.377C414.823 210.688 414.72 210.999 414.72 211.31C414.616 211.31 414.72 211.62 414.823 211.828ZM423.226 182.187C423.33 182.498 423.33 182.808 423.226 183.119C423.122 183.43 422.915 183.638 422.707 183.845C422.5 184.052 422.188 184.156 421.877 184.156C421.566 184.156 421.255 184.156 420.944 183.949C420.632 183.845 420.425 183.534 420.321 183.327C420.218 183.016 420.114 182.705 420.114 182.394C420.114 182.083 420.321 181.772 420.529 181.565C420.736 181.358 421.047 181.15 421.255 181.047C421.462 180.943 421.67 180.943 421.877 180.943C422.085 180.943 422.292 181.047 422.5 181.15C422.707 181.254 422.811 181.358 423.018 181.565C423.122 181.876 423.226 181.979 423.226 182.187Z",
    fill: "#FD3E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.611 266.653L418.454 281.474C416.794 281.888 415.135 281.992 413.475 281.785C411.815 281.578 410.155 280.956 408.703 280.127C407.251 279.297 406.006 278.157 404.969 276.81C403.931 275.463 403.205 273.908 402.79 272.25C402.376 270.592 402.272 268.933 402.479 267.275C402.687 265.617 403.309 263.959 404.139 262.508C404.969 261.057 406.11 259.813 407.458 258.777C408.807 257.74 410.363 257.015 412.023 256.6L469.179 241.78C472.499 240.951 475.922 241.469 478.93 243.127C481.835 244.889 484.013 247.687 484.843 250.9C485.673 254.217 485.258 257.74 483.494 260.642C481.731 263.648 478.93 265.824 475.611 266.653Z",
    fill: "#5B5863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.101 272.768L430.591 272.146L423.122 261.471L420.84 262.093L419.595 275.048L422.085 274.426L422.292 271.835L426.856 270.592L428.101 272.768ZM422.292 269.659L422.603 264.581L425.404 268.83L422.292 269.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.043 271.732L439.616 269.763L439.097 267.69L433.806 269.037L431.213 259.295L428.827 259.917L432.043 271.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.483 269.244L449.366 267.172L448.848 265.099L443.246 266.55L442.52 263.751L446.669 262.611L446.151 260.539L442.001 261.679L441.275 258.88L446.462 257.533L445.943 255.46L438.371 257.429L441.483 269.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.466 264.166L456.42 260.642C456.835 260.331 457.25 260.02 457.561 259.606C457.872 259.191 457.976 258.777 458.08 258.155C458.184 257.637 458.08 257.015 457.976 256.393C457.872 255.771 457.561 255.357 457.354 254.838C457.043 254.424 456.731 254.113 456.316 253.802C455.901 253.491 455.383 253.387 454.76 253.284C454.138 253.18 453.516 253.284 452.893 253.491L448.433 254.631L451.545 266.446L453.827 265.824L452.789 261.782L454.138 261.471L457.872 264.788L460.466 264.166ZM451.234 256.289L452.997 255.875C453.619 255.668 454.242 255.771 454.657 255.978C455.072 256.186 455.383 256.6 455.59 257.119C455.694 257.637 455.694 258.155 455.383 258.569C455.072 258.984 454.553 259.295 453.827 259.502L452.167 259.917L451.234 256.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.408 263.13L466.69 262.508L464.097 252.766L467.312 251.937L466.794 249.864L457.976 252.247L458.495 254.32L461.711 253.491L464.408 263.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.252 421.077C332.252 421.077 314.929 380.761 323.642 331.843",
    stroke: "#DA2858",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.506 299.3C311.506 299.3 279.245 331.221 257.668 339.823",
    stroke: "#DA2858",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.698 290.698C205.698 290.698 199.786 333.812 221.777 342",
    stroke: "#DA2858",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.563 377.859C143.563 377.859 143.355 321.272 154.662 303.757",
    stroke: "#DA2858",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.43 385.36L170.412 385.333C170.413 385.331 170.414 385.329 170.415 385.327C170.419 385.322 170.422 385.316 170.427 385.309C170.438 385.316 170.449 385.324 170.46 385.333C171.308 386.651 182.649 403.49 196.86 419.503C204.176 427.747 212.273 435.794 220.109 441.395C227.911 446.971 235.587 450.219 242.015 448.611C242.022 448.623 242.029 448.638 242.036 448.656C242.021 448.665 242.001 448.674 241.977 448.683C240.956 448.886 239.763 449.081 238.582 449.081C232.272 449.081 224.967 445.343 217.479 439.572C210.009 433.816 202.439 426.102 195.609 418.289C181.95 402.664 171.306 386.698 170.43 385.36Z",
    fill: "#DA2858",
    stroke: "#F5FAFF",
    strokeWidth: 0.993924
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M455.383 369.983C457.872 368.013 459.428 366.666 459.947 366.252C459.428 366.77 457.872 368.117 455.383 369.983Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.654 377.134C400.093 399.831 427.894 395.685 449.678 366.355C449.678 366.355 467.831 343.036 466.482 317.852C465.237 292.667 459.221 210.584 380.695 231.623C367.729 235.043 337.646 275.463 335.053 286.552C333.912 291.631 321.775 317.437 310.053 344.073",
    fill: "#1A4DBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.654 377.134C400.093 399.831 427.894 395.685 449.678 366.355C449.678 366.355 467.831 343.036 466.482 317.852C465.237 292.667 459.221 210.584 380.695 231.623C367.729 235.043 337.646 275.463 335.053 286.552C333.912 291.631 321.775 317.437 310.053 344.073",
    stroke: "#B0BAF1",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.398 136.067C272.398 136.067 294.39 132.75 309.638 146.431C328.933 163.635 350.613 210.17 319.7 287.278C319.7 287.278 274.162 257.015 196.362 277.328C196.362 277.328 203.105 259.295 191.279 202.293C185.989 176.486 199.371 117.101 272.398 136.067Z",
    fill: "#1B1A53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1 329.459C271.569 334.745 306.112 298.782 306.112 298.782C306.112 298.782 288.477 296.605 286.817 288.314C281.735 262.197 302.17 229.861 302.17 229.861C302.17 229.861 223.229 232.038 237.026 249.864C239.619 253.077 241.694 256.704 243.25 260.539C248.021 272.25 244.702 281.163 242.212 283.34C242.005 283.443 241.797 283.65 241.59 283.754C236.818 285.931 217.213 282.718 217.213 282.718C217.213 282.718 209.433 324.692 239.1 329.459Z",
    fill: "#F1B287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.316 283.339C266.486 289.661 277.793 258.673 277.793 258.673C277.793 258.673 270.843 256.6 262.025 256.6C256.112 256.6 249.37 257.533 243.353 260.539C248.125 272.354 244.806 281.163 242.316 283.339Z",
    fill: "#E3A275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.622 213.59C309.535 180.632 303 141.042 252.689 144.358C216.798 146.742 217.109 186.021 219.495 197.733C223.54 217.424 217.731 225.197 223.955 241.78C228.416 253.698 238.685 267.068 250.718 272.043C258.187 275.152 288.27 254.009 290.552 244.371",
    fill: "#F1B287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.672 156.898C271.672 156.898 268.457 195.971 303 210.17L319.182 172.548L294.701 145.394L257.876 134.719C202.794 138.14 179.039 172.341 209.64 263.441C209.64 263.648 201.03 155.137 271.672 156.898Z",
    fill: "#1F3476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.427 211.828C294.908 207.475 306.112 196.282 309.846 203.433C316.277 215.662 311.609 226.234 304.97 230.587C301.962 232.452 298.228 235.976 295.635 232.659",
    fill: "#F1B287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.427 211.828C294.908 207.475 306.112 196.282 309.846 203.433C316.277 215.662 311.609 226.234 304.97 230.587C301.962 232.452 298.228 235.976 295.635 232.659",
    stroke: "#F1B287",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M203.831 209.237C203.52 209.237 203.312 208.926 203.312 208.719C203.52 206.024 203.727 203.329 204.142 200.635C204.142 200.324 204.454 200.116 204.765 200.22C205.076 200.22 205.283 200.531 205.18 200.842C204.765 203.433 204.454 206.128 204.35 208.822C204.35 209.03 204.142 209.237 203.831 209.237Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M205.906 195.245H205.802C205.491 195.142 205.387 194.934 205.387 194.623C211.3 167.573 236.714 148.504 265.863 149.333C266.175 149.333 266.382 149.54 266.382 149.851C266.382 150.162 266.175 150.369 265.863 150.369C237.233 149.644 212.234 168.299 206.425 194.934C206.425 195.038 206.217 195.245 205.906 195.245Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M205.595 159.49C205.491 159.49 205.387 159.49 205.387 159.386C205.18 159.282 205.076 158.971 205.18 158.66C220.325 131.921 260.677 141.145 261.092 141.249C261.403 141.353 261.506 141.56 261.506 141.871C261.403 142.182 261.195 142.285 260.884 142.285C260.469 142.182 220.843 133.269 206.113 159.282C206.009 159.49 205.802 159.49 205.595 159.49Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M302.273 197.94C302.17 197.94 302.066 197.94 301.962 197.836C298.643 195.245 295.635 192.136 293.145 188.612C292.937 188.405 293.041 188.094 293.249 187.887C293.456 187.68 293.767 187.783 293.975 187.991C296.361 191.411 299.265 194.416 302.585 197.007C302.792 197.215 302.896 197.525 302.688 197.733C302.585 197.836 302.377 197.94 302.273 197.94Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.344 183.845C290.137 183.845 290.033 183.741 289.929 183.534C283.498 172.237 279.141 159.904 277.067 147.053C277.067 146.742 277.17 146.534 277.481 146.431C277.793 146.431 278 146.534 278.104 146.845C280.179 159.593 284.432 171.719 290.863 183.016C290.967 183.223 290.967 183.534 290.656 183.741C290.552 183.845 290.448 183.845 290.344 183.845Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M315.551 277.95H315.448C315.136 277.847 315.033 277.536 315.136 277.328C316.07 274.116 316.9 270.903 317.626 267.897C317.73 267.586 317.937 267.483 318.248 267.483C318.56 267.586 318.663 267.793 318.663 268.104C317.937 271.214 317.107 274.426 316.174 277.639C315.966 277.847 315.759 277.95 315.551 277.95Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M319.078 263.13C318.663 263.026 318.559 262.819 318.559 262.508C320.842 249.345 322.19 230.483 315.24 215.041C315.136 214.73 315.24 214.522 315.551 214.315C315.862 214.211 316.07 214.315 316.277 214.626C323.331 230.276 322.086 249.449 319.7 262.715C319.597 262.922 319.389 263.13 319.078 263.13Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M299.576 270.281C299.473 270.281 299.265 270.281 299.161 270.177C298.954 269.97 298.954 269.659 299.161 269.452C303 265.617 306.008 261.057 307.875 255.978C309.846 250.9 310.676 245.511 310.365 240.121C310.365 239.811 310.572 239.603 310.883 239.603C311.194 239.603 311.402 239.811 311.402 240.121C311.713 245.718 310.883 251.211 308.912 256.497C306.941 261.782 303.933 266.446 299.888 270.384C299.888 270.281 299.68 270.281 299.576 270.281Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M330.489 211.413C330.281 211.413 329.97 211.206 329.97 210.999C328.414 198.769 320.323 188.716 311.817 179.699C306.734 174.31 302.792 168.195 298.954 162.288C296.776 158.868 294.39 155.344 291.9 152.027C291.693 151.82 291.796 151.509 292.004 151.302C292.211 151.095 292.523 151.198 292.73 151.406C295.22 154.826 297.502 158.349 299.784 161.77C303.622 167.573 307.564 173.688 312.543 178.974C321.153 188.198 329.348 198.355 331.007 210.895C331.111 211.102 330.904 211.413 330.489 211.413C330.592 211.413 330.489 211.413 330.489 211.413Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.062 147.053C287.958 147.053 287.751 146.949 287.647 146.845C286.091 145.187 284.328 143.736 282.357 142.389C282.149 142.182 282.046 141.871 282.253 141.663C282.461 141.456 282.772 141.352 282.979 141.56C284.95 142.907 286.817 144.358 288.477 146.12C288.685 146.327 288.685 146.638 288.477 146.845C288.373 147.053 288.27 147.053 288.062 147.053Z",
    fill: "#DBDBDB"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M420.425 356.613C419.595 356.82 418.869 356.924 418.039 357.028C396.463 360.137 372.189 342.207 364.098 320.754C357.667 303.757 363.268 284.583 366.38 276.292C367.314 273.701 368.04 272.25 368.04 272.25C381.11 253.698 456.835 289.972 457.665 310.079C458.391 330.081 442.52 351.742 420.425 356.613Z",
    fill: "#153E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.076 312.773C444.076 312.773 439.823 344.591 417.935 357.028C396.359 360.137 372.086 342.207 363.994 320.754C357.563 303.757 363.165 284.583 366.276 276.292C391.795 261.782 444.076 312.773 444.076 312.773Z",
    fill: "#F1B287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.852 368.532C411.296 368.532 409.637 368.428 407.977 368.324C379.347 365.422 354.555 330.288 354.243 329.874C354.036 329.667 354.14 329.356 354.347 329.148C354.555 328.941 354.866 329.045 355.073 329.252C355.281 329.563 379.865 364.386 407.977 367.288C423.018 368.843 433.703 362.831 440.03 357.442C449.055 349.773 454.968 338.683 455.694 328.319C455.694 328.008 455.901 327.801 456.213 327.801C456.524 327.801 456.731 328.112 456.731 328.319C456.109 338.891 449.989 350.395 440.756 358.168C435.155 363.039 425.819 368.532 412.852 368.532Z",
    fill: "#B0BAF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.966 170.372C343.144 164.361 358.6 166.33 363.579 185.192C368.455 204.055 387.853 249.864 387.853 249.864C387.853 249.864 464.926 136.481 478.723 132.128C492.519 127.776 487.125 147.364 468.661 174.621C468.661 174.621 485.984 171.615 490.548 174.621C495.112 177.626 492.83 196.074 495.32 202.396C499.365 213.175 490.341 215.455 490.341 215.455C494.801 215.559 499.054 217.217 502.374 220.015C507.353 224.679 504.863 243.853 506.212 249.242C507.664 254.631 498.121 259.191 498.121 259.191C498.121 259.191 520.838 271.524 515.755 274.634C507.145 279.816 502.166 274.53 502.166 274.53C502.166 274.53 467.208 318.37 440.964 328.112C414.616 337.854 363.372 299.093 357.874 277.95C352.376 256.808 358.911 258.155 354.762 223.021C350.613 187.887 340.966 170.372 340.966 170.372Z",
    fill: "#F1B287",
    stroke: "#FFDAC7",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.412 100.725L351.858 127.154C348.227 128.086 346.049 131.818 347.086 135.341L395.114 319.303C396.048 322.93 399.782 325.106 403.309 324.07L504.863 297.642C508.494 296.709 510.672 292.978 509.635 289.454L461.607 105.597C460.673 101.969 457.043 99.7927 453.412 100.725Z",
    fill: "#B0BAF1",
    stroke: "#B0BAF1",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.218 121.868C395.322 122.075 395.322 122.283 395.218 122.49C395.218 122.697 395.114 122.904 395.01 123.112C394.907 123.319 394.803 123.423 394.595 123.63C394.388 123.734 394.18 123.837 393.973 123.941C393.766 124.045 393.558 124.045 393.351 123.941C393.143 123.941 392.936 123.837 392.728 123.734C392.521 123.63 392.417 123.526 392.21 123.319C392.106 123.112 392.002 122.904 391.898 122.697C391.795 122.49 391.795 122.283 391.898 122.075C391.898 121.868 392.002 121.661 392.106 121.454C392.21 121.246 392.313 121.143 392.521 120.935C392.728 120.728 392.936 120.728 393.143 120.624C393.558 120.521 393.973 120.624 394.388 120.832C394.803 121.143 395.114 121.454 395.218 121.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.172 116.479C416.172 116.582 416.172 116.79 416.172 116.893C416.172 116.997 416.068 117.204 416.068 117.308C415.964 117.412 415.861 117.515 415.757 117.619C415.653 117.722 415.55 117.722 415.342 117.826C415.135 117.826 414.927 117.826 414.72 117.826C414.512 117.722 414.408 117.619 414.201 117.515C414.097 117.308 413.994 117.204 413.994 116.997C413.994 116.79 413.994 116.582 414.097 116.375C414.201 116.168 414.305 116.064 414.512 115.961C414.72 115.857 414.927 115.857 415.135 115.857C415.342 115.857 415.55 115.961 415.653 116.064C415.964 116.064 416.068 116.271 416.172 116.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.089 118.966L398.849 122.075C398.641 122.179 398.434 122.386 398.537 122.594L398.641 122.801C398.745 123.008 398.952 123.215 399.16 123.112L411.4 120.003C411.608 119.899 411.815 119.692 411.711 119.484L411.608 119.277C411.608 119.07 411.4 118.966 411.089 118.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.599 107.462L506.212 289.972C506.523 291.009 506.316 292.045 505.797 292.978C505.278 293.911 504.345 294.533 503.411 294.844L403.102 320.857C402.064 321.168 401.027 320.961 400.093 320.443C399.16 319.924 398.537 318.992 398.226 318.059L350.613 135.549C350.302 134.512 350.509 133.476 351.028 132.543C351.546 131.61 352.48 130.988 353.414 130.678L373.953 125.288C374.575 125.081 375.301 125.185 375.924 125.392C376.546 125.599 377.168 126.014 377.48 126.636L378.932 128.812C379.347 129.33 379.866 129.745 380.488 130.056C381.11 130.263 381.836 130.367 382.459 130.159L427.583 118.448C428.205 118.241 428.827 117.93 429.242 117.412C429.657 116.893 429.968 116.272 430.072 115.65L430.383 113.059C430.487 112.437 430.694 111.711 431.213 111.193C431.628 110.675 432.25 110.364 432.873 110.157L453.412 104.767C454.449 104.457 455.487 104.664 456.42 105.182C457.561 105.597 458.287 106.426 458.599 107.462Z",
    fill: "#1ABE6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.574 207.268C455.279 194.002 449.263 178.663 435.985 172.963C422.707 167.263 407.355 173.274 401.649 186.54C395.944 199.806 401.96 215.144 415.238 220.844C428.412 226.545 443.868 220.534 449.574 207.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M404.346 221.466C403.932 221.466 403.62 221.363 403.309 221.052C398.745 216.802 395.425 211.413 393.869 205.402C392.21 199.391 392.417 193.069 394.284 187.058C394.492 186.229 395.425 185.814 396.255 186.021C397.085 186.229 397.5 187.161 397.293 187.99C395.633 193.38 395.529 199.08 396.981 204.573C398.434 210.066 401.442 214.937 405.591 218.772C406.214 219.393 406.214 220.326 405.695 220.948C405.176 221.259 404.761 221.466 404.346 221.466ZM455.487 207.786C455.383 207.786 455.175 207.786 455.072 207.682C454.242 207.475 453.827 206.542 454.034 205.713C455.694 200.324 455.798 194.623 454.346 189.131C452.893 183.638 449.885 178.767 445.736 174.932C445.113 174.31 445.113 173.377 445.632 172.755C446.254 172.134 447.188 172.134 447.81 172.652C452.375 176.901 455.694 182.29 457.25 188.301C458.91 194.313 458.702 200.635 456.835 206.646C456.835 207.371 456.213 207.786 455.487 207.786Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M402.79 231.208C402.375 231.208 401.961 231.105 401.649 230.794C393.662 225.197 387.957 217.01 385.363 207.579C382.874 198.147 383.704 188.198 387.853 179.388C388.372 178.352 389.616 177.937 390.654 178.352C391.691 178.87 392.106 180.114 391.691 181.15C387.957 189.027 387.23 198.147 389.513 206.542C391.795 215.041 396.981 222.399 404.139 227.477C405.072 228.099 405.28 229.447 404.658 230.379C404.139 230.898 403.517 231.208 402.79 231.208ZM461.399 215.559C461.088 215.559 460.777 215.455 460.569 215.352C459.532 214.833 459.117 213.59 459.532 212.553C463.266 204.677 463.993 195.556 461.711 187.161C459.428 178.663 454.242 171.304 447.084 166.226C446.151 165.604 445.943 164.257 446.566 163.324C447.188 162.391 448.536 162.184 449.47 162.806C457.457 168.403 463.163 176.59 465.756 186.021C468.246 195.453 467.416 205.402 463.266 214.211C462.955 215.041 462.125 215.559 461.399 215.559Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M399.575 241.883C399.16 241.883 398.641 241.78 398.226 241.469C386.712 234.421 378.413 223.332 374.886 210.377C371.359 197.318 373.019 183.638 379.45 171.719C380.177 170.475 381.733 169.957 382.977 170.683C384.222 171.408 384.741 172.963 384.015 174.206C378.206 184.881 376.753 197.215 379.865 209.029C382.977 220.741 390.446 230.794 400.819 237.116C402.064 237.841 402.479 239.5 401.649 240.64C401.338 241.469 400.508 241.883 399.575 241.883ZM469.283 223.228C468.868 223.228 468.453 223.125 468.038 222.917C466.793 222.192 466.275 220.637 467.001 219.394C472.81 208.719 474.262 196.385 471.15 184.57C468.038 172.859 460.569 162.806 450.196 156.484C448.951 155.758 448.536 154.1 449.366 152.96C450.196 151.82 451.752 151.302 452.893 152.131C464.407 159.179 472.706 170.268 476.233 183.223C479.76 196.282 478.1 209.962 471.669 221.881C471.046 222.71 470.216 223.228 469.283 223.228Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.823 211.828C415.031 212.346 415.446 212.76 415.964 212.968C416.483 213.175 417.105 213.279 417.624 213.071L426.234 210.584C426.234 210.791 426.338 210.999 426.338 211.102C426.441 211.517 426.649 211.931 426.96 212.346C427.271 212.76 427.582 212.968 427.997 213.279C428.412 213.486 428.827 213.693 429.346 213.693C429.761 213.693 430.279 213.693 430.694 213.59C431.109 213.486 431.524 213.279 431.939 212.968C432.354 212.657 432.562 212.346 432.873 211.931C433.08 211.517 433.288 211.102 433.288 210.584C433.288 210.169 433.288 209.651 433.184 209.237C433.08 209.029 433.08 208.926 432.976 208.718L441.586 206.231C442.105 206.127 442.624 205.713 442.935 205.195C443.246 204.677 443.35 204.158 443.246 203.536C443.142 203.226 443.039 202.915 442.935 202.707C442.727 202.396 442.52 202.189 442.209 202.086C441.897 201.878 441.69 201.775 441.379 201.775C441.068 201.775 440.756 201.775 440.445 201.878L439.719 201.464C438.163 200.531 437.022 199.08 436.503 197.318L434.844 191.721C434.221 189.441 432.665 187.369 430.694 186.125C428.62 184.778 426.234 184.259 423.848 184.674C424.263 184.259 424.47 183.638 424.574 183.119C424.678 182.601 424.47 181.876 424.159 181.461C423.848 180.943 423.329 180.528 422.811 180.321C422.292 180.114 421.67 180.114 421.047 180.217C420.425 180.425 420.01 180.736 419.595 181.254C419.284 181.772 419.076 182.29 419.076 182.912C419.076 183.534 419.284 184.052 419.699 184.57C420.114 185.089 420.632 185.399 421.151 185.503C418.869 186.436 417.105 188.198 416.068 190.478C415.031 192.654 414.823 195.245 415.549 197.525L417.209 203.226C417.52 204.262 417.624 205.298 417.417 206.335C417.313 207.371 416.898 208.304 416.275 209.237C415.964 209.34 415.653 209.444 415.446 209.651C415.238 209.859 415.031 210.066 414.927 210.377C414.823 210.688 414.719 210.999 414.719 211.309C414.616 211.309 414.719 211.62 414.823 211.828ZM423.226 182.187C423.329 182.498 423.329 182.808 423.226 183.119C423.122 183.43 422.914 183.638 422.707 183.845C422.499 184.052 422.188 184.156 421.877 184.156C421.566 184.156 421.255 184.156 420.943 183.948C420.632 183.845 420.425 183.534 420.321 183.327C420.217 183.016 420.114 182.705 420.114 182.394C420.114 182.083 420.321 181.772 420.528 181.565C420.736 181.357 421.047 181.15 421.255 181.047C421.462 180.943 421.67 180.943 421.877 180.943C422.085 180.943 422.292 181.047 422.499 181.15C422.707 181.254 422.811 181.357 423.018 181.565C423.122 181.876 423.226 181.979 423.226 182.187Z",
    fill: "#1E1F25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.611 266.653L418.454 281.474C416.794 281.888 415.135 281.992 413.475 281.785C411.815 281.578 410.155 280.956 408.703 280.127C407.251 279.297 406.006 278.157 404.969 276.81C403.931 275.463 403.205 273.908 402.79 272.25C402.376 270.592 402.272 268.933 402.479 267.275C402.687 265.617 403.309 263.959 404.139 262.508C404.969 261.057 406.11 259.813 407.458 258.777C408.807 257.74 410.363 257.015 412.023 256.6L469.179 241.78C472.499 240.951 475.922 241.469 478.93 243.127C481.835 244.889 484.013 247.687 484.843 250.9C485.673 254.217 485.258 257.74 483.494 260.642C481.731 263.648 478.93 265.824 475.611 266.653Z",
    fill: "#1E1F25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.101 272.768L430.591 272.146L423.122 261.471L420.84 262.093L419.595 275.048L422.085 274.426L422.292 271.835L426.856 270.592L428.101 272.768ZM422.292 269.659L422.603 264.581L425.404 268.83L422.292 269.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.043 271.732L439.616 269.763L439.097 267.69L433.806 269.037L431.213 259.295L428.827 259.917L432.043 271.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.483 269.244L449.366 267.172L448.848 265.099L443.246 266.55L442.52 263.751L446.669 262.611L446.151 260.539L442.001 261.679L441.275 258.88L446.462 257.533L445.943 255.46L438.371 257.429L441.483 269.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.466 264.166L456.42 260.642C456.835 260.331 457.25 260.02 457.561 259.606C457.872 259.191 457.976 258.777 458.08 258.155C458.184 257.637 458.08 257.015 457.976 256.393C457.872 255.771 457.561 255.357 457.354 254.838C457.043 254.424 456.731 254.113 456.316 253.802C455.901 253.491 455.383 253.387 454.76 253.284C454.138 253.18 453.516 253.284 452.893 253.491L448.433 254.631L451.545 266.446L453.827 265.824L452.789 261.782L454.138 261.471L457.872 264.788L460.466 264.166ZM451.234 256.289L452.997 255.875C453.619 255.668 454.242 255.771 454.657 255.978C455.072 256.186 455.383 256.6 455.59 257.119C455.694 257.637 455.694 258.155 455.383 258.569C455.072 258.984 454.553 259.295 453.827 259.502L452.167 259.917L451.234 256.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.408 263.13L466.69 262.508L464.096 252.766L467.312 251.936L466.793 249.864L457.976 252.247L458.495 254.32L461.71 253.491L464.408 263.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.252 421.077C332.252 421.077 314.929 380.761 323.642 331.843",
    stroke: "#B0BAF1",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.668 340.341C257.461 340.341 257.253 340.238 257.15 340.031C257.046 339.72 257.15 339.512 257.461 339.409C278.726 331.014 310.883 299.404 311.194 299.093C311.402 298.885 311.713 298.885 311.921 299.093C312.128 299.3 312.128 299.611 311.921 299.818C311.609 300.129 279.349 331.947 257.876 340.445C257.772 340.341 257.668 340.341 257.668 340.341Z",
    fill: "#B0BAF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.698 290.698C205.698 290.698 199.786 333.812 221.777 342",
    stroke: "#B0BAF1",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.563 377.859C143.563 377.859 143.355 321.272 154.662 303.757",
    stroke: "#F5FAFF",
    strokeWidth: 0.993924,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M455.383 369.983C457.872 368.013 459.428 366.666 459.947 366.252C459.428 366.77 457.872 368.117 455.383 369.983Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_50_946)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M108.551 249.103C149.725 249.103 183.103 215.725 183.103 174.551C183.103 133.378 149.725 100 108.551 100C67.3777 100 34 133.378 34 174.551C34 215.725 67.3777 249.103 108.551 249.103Z",
    fill: "#0054FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.551 224.863C136.337 224.863 158.862 202.338 158.862 174.552C158.862 146.765 136.337 124.24 108.551 124.24C80.7653 124.24 58.2404 146.765 58.2404 174.552C58.2404 202.338 80.7653 224.863 108.551 224.863Z",
    fill: "#0054FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.552 206.261C125.762 206.261 139.714 192.309 139.714 175.098C139.714 157.888 125.762 143.936 108.552 143.936C91.341 143.936 77.3889 157.888 77.3889 175.098C77.3889 192.309 91.341 206.261 108.552 206.261Z",
    fill: "#0054FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.552 195.676C119.911 195.676 129.12 186.468 129.12 175.109C129.12 163.749 119.911 154.541 108.552 154.541C97.1931 154.541 87.9846 163.749 87.9846 175.109C87.9846 186.468 97.1931 195.676 108.552 195.676Z",
    fill: "url(#paint15_linear_50_946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.552 195.452C119.788 195.452 128.896 186.344 128.896 175.109C128.896 163.873 119.788 154.765 108.552 154.765C97.3166 154.765 88.2084 163.873 88.2084 175.109C88.2084 186.344 97.3166 195.452 108.552 195.452Z",
    stroke: "white",
    strokeOpacity: 0.22,
    strokeWidth: 0.447618
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_50_946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.1211 163.578H133.555L108.185 190.964L84.1211 163.578Z",
    fill: "#1A47AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.071 196.198H87.6052V160.638C87.6052 159.095 88.2182 157.615 89.3092 156.524C90.4002 155.433 91.88 154.82 93.423 154.82H124.254C125.797 154.82 127.276 155.433 128.367 156.524C129.458 157.615 130.071 159.095 130.071 160.638V196.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1211 163.578L130.071 196.198H87.6052C86.6818 196.198 85.7961 195.831 85.1428 195.179C84.4896 194.526 84.1221 193.641 84.1211 192.717V163.578Z",
    fill: "#1ABE6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.555 163.578L87.6052 196.198H130.071C130.995 196.198 131.88 195.831 132.534 195.179C133.187 194.526 133.555 193.641 133.555 192.717V163.578Z",
    fill: "#1E1F25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.071 161.317C132.429 161.317 134.341 159.405 134.341 157.048C134.341 154.69 132.429 152.778 130.071 152.778C127.714 152.778 125.802 154.69 125.802 157.048C125.802 159.405 127.714 161.317 130.071 161.317Z",
    fill: "#E66260"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_50_946",
    x: 75.2344,
    y: 148.396,
    width: 67.8712,
    height: 60.9894,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.38248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.11691 0 0 0 0 0.45045 0 0 0 0 0.758333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_50_946"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_50_946",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_946",
    x1: 360.822,
    y1: 273.476,
    x2: 360.822,
    y2: 549.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_50_946",
    x1: 173.977,
    y1: 250.966,
    x2: 173.977,
    y2: 549.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_50_946",
    x1: 44.6144,
    y1: 120,
    x2: 44.6144,
    y2: 550.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_50_946",
    x1: 104.092,
    y1: 218.225,
    x2: 104.092,
    y2: 549.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_50_946",
    x1: 276.835,
    y1: 177.296,
    x2: 276.835,
    y2: 549.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_50_946",
    x1: 406.444,
    y1: 265.29,
    x2: 406.444,
    y2: 549.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_50_946",
    x1: 483.796,
    y1: 258.129,
    x2: 483.796,
    y2: 549.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_50_946",
    x1: 464.716,
    y1: 293.939,
    x2: 464.716,
    y2: 549.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_50_946",
    x1: 506.347,
    y1: 218.187,
    x2: 506.347,
    y2: 550.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_50_946",
    x1: 480.384,
    y1: 379.78,
    x2: 480.384,
    y2: 549.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_50_946",
    x1: 148.055,
    y1: 338.958,
    x2: 148.055,
    y2: 549.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_50_946",
    x1: 7.24744,
    y1: 401.168,
    x2: 7.24744,
    y2: 550.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_50_946",
    x1: 233.002,
    y1: 287.28,
    x2: 233.002,
    y2: 550.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_50_946",
    x1: 381.559,
    y1: 231.525,
    x2: 381.559,
    y2: 549.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_50_946",
    x1: 38.9819,
    y1: 411.093,
    x2: 446.634,
    y2: 411.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#356FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_50_946",
    x1: 126.076,
    y1: 154.541,
    x2: 93.7847,
    y2: 190.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 540,
    rx: 270,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_50_946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 478,
    height: 447,
    fill: "white",
    transform: "translate(39 100)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_50_946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.103,
    height: 149.103,
    fill: "white",
    transform: "translate(34 100)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1Img);
export default __webpack_public_path__ + "static/media/Feature1Img.b39505b8a9c2667d66a05600c7c0fbf5.svg";
export { ForwardRef as ReactComponent };